<template>
  <main class="container-fluid pb_50">
    <SelectCustomer
      :insurer.sync="insurer"
      :insured.sync="insured"
      ref="SelectCustomer"
      @closeScNotice="closeScNotice = true"
      @customer-change="markCustomerChanged"
    />
    <SelectProduct
      :checkCustomerIsvalid="checkCustomerIsvalid"
      :mainProductSelected.sync="mainProductSelected"
      :closeScNotice="closeScNotice"
      ref="SelectProduct"
      class="mb_30"
    />
    <FixedBottom>
      <template slot="@function">
        <div class="d-flex justify-content-end">
          <!-- <button
            class="btn btn-default mr_10"
            type="button"
            @click="resetProduct()"
          >
            清除重選
          </button> -->
          <button
            class="btn btn-primary mr_10"
            type="button"
            :disabled="!is_selected_mc"
            @click.stop="openComposeNamePopup = true"
          >
            將本次商品加入我的收藏
          </button>
          <button
            class="btn btn-primary mr_15"
            @click="saveAndNext()"
            :disabled="!storeCanSave || !canSave || !is_selected_mc"
          >
            儲存並進入下一步
          </button>
        </div>
      </template>
    </FixedBottom>
    <AddMyComposePopup
      :open="openComposeNamePopup"
      @close="openComposeNamePopup = false"
      @success="openComposeNamePopup = false"
    />

    <warning-modal
      :open="warningModalOpen"
      :message="warningMessage"
      :showCancel="false"
      :confirm-checkbox.sync="warningConfirmCheckbox"
      @submit="confirmWarningModal"
      @send="openSendEmailModal()"
      @close="panelClose('warningModalOpen')"
      @download="download"
    />

    <send-email-modal
      :open="sendEmailModalOpen"
      :isBnk="false"
      :senderName="$store.state.userInfo.name"
      @close="closeEmailModal"
      @doSendEmail="doSendEmail"
    />
  </main>
</template>

<script>
import SelectCustomer from "@/desktop/views/mf/components/1.Create/1-1-1.Customer/Index.vue";
import SelectProduct from "@/desktop/views/mf/components/1.Create/1-1-2.Product/Index.vue";
import FixedBottom from "@/desktop/views/mf/components/fixedBotton";
import AddMyComposePopup from "@/desktop/views/mf/components/1.Create/1-1-3.AddMyCompose/Index.vue";
import WarningModal from "@/desktop/views/mf/components/1.Create/1-1-1.Customer/WarningModal3.vue";
import SendEmailModal from "@/desktop/views/mf/components/1.Create/1-1-1.Customer/SendEmailModal.vue";

import mf_Mixin from "@/desktop/views/mf/mixin";
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";
import { commonMixin } from "@/mixins/common";
//api
import { getAllFamily, getFamilyMemberByCsidNo } from "@/service";
export default {
  mixins: [mf_Mixin, commonMixin],
  components: {
    SelectCustomer,
    SelectProduct,
    FixedBottom,
    AddMyComposePopup,
    WarningModal,
    SendEmailModal,
  },
  data() {
    return {
      insurer: null, //要保人資訊
      insured: null, //被保人資訊
      selectCustomerTempData: null, //選擇客戶區塊緩存，若變更要被保人則詢問是否重選商品。
      mainProductSelected: [], //已選商品清單(主約)，保存後下一步才更新VUEX的物件
      canSave: true,
      familyid: "",
      openComposeNamePopup: false,
      alreadyAddMyCompose: false,
      closeScNotice: false,
      warningMessage: "",
      warningModalOpen: false,
      // 個資彈窗 checkbox 狀態；寄信視窗返回時需要保留已勾選狀態。
      warningConfirmCheckbox: false,
      sendEmailModalOpen: false,
      // 個資聲明的客戶資料比對基準；確認聲明後會更新成當下資料。
      tempData: {
        insurer_name: "",
        insurer_id: "",
        insurer_gender: "",
        insurer_birthday: "",
        insurer_age: "",
        insured_name: "",
        insured_id: "",
        insured_gender: "",
        insured_birthday: "",
        insured_age: "",
      },
      hasConfirmedWarning: false, //目前這份客戶資料是否已同意過個資聲明
      // 已修改客戶資料但尚未重新確認個資聲明。
      hasUnconfirmedCustomerChange: false,
      // 等 created 初始化快照完成後才開始追蹤，避免初始化資料被誤判成異動。
      customerChangeTrackingReady: false,
    };
  },
  created() {
    this.init();
    let currentEditing = this.$store.getters.MfEditing;
    const storedTempData = this.getPrivacyCustomerCompareData();

    this.tempData =
      storedTempData || this.getCustomerCompareData(currentEditing);
    if (!storedTempData) {
      this.setPrivacyCustomerCompareData(this.tempData);
    }
    this.hasUnconfirmedCustomerChange =
      this.$store.state.mf.privacyCustomerChanged || this.isCustomerChanged();
    this.setPrivacyCustomerChanged(this.hasUnconfirmedCustomerChange);
    if (currentEditing.insurer && currentEditing.insured) {
      this.$store.commit("set_customerDataTempJSON");
    }
    this.$nextTick(() => {
      this.customerChangeTrackingReady = true;
    });
  },
  mounted() {
    if (this.$store.state.userInfo.userType === "box") {
      //接Box參數
      window.getCustInfoFromBox = (data) => {
        this.getCustInfoFromBox(data);
      };
      //告知APP,頁面已加載完畢(NAP->呼叫預帶客戶資料方法)
      this.isReadyListenAppJS();
    }
    setTimeout(() => {
      this.registerHanlink();
    }, 100);
  },
  computed: {
    ...mapGetters(["CustInfo", "UserInfo"]),
    is_selected_mc() {
      return this.$store.getters.MfEditing.mc_prod_list.length > 0;
    },
    storeCanSave() {
      return this.$store.getters.CanSave;
    },
    isBox() {
      return this.UserInfo.userType === "box";
    },
  },
  methods: {
    async init() {
      let currentEditing = this.$store.getters.MfEditing;
      //進來時都用prod_idx進行查找，若prod_idx沒有，則視為新增
      if (currentEditing.prod_idx != "") {
        const result = await getFamilyMemberByCsidNo(
          this.$store.state.userInfo.id,
          currentEditing.insured.insured_id,
        );
        this.familyid = result.data[0].familyid;
        let memberList = result.data.map((item) => {
          item.insured_name = item.name;
          item.insured_id = item.csidno;
          item.insured_gender = item.sex;
          item.insured_birthday =
            !item.birthday || item.birthday == ""
              ? ""
              : moment(item.birthday + "").format("YYYY-MM-DD");
          item.insured_age = item.age + "";
          item.job_cat = "";
          return item;
        });
        this.$store.commit(
          "set_MemberList",
          memberList.sort((a, b) => a.familyrl - b.familyrl),
        );
      }
      this.registerHanlink();
    },
    //將此方法傳給子組件，用來檢核選擇客戶是否符合格式
    async checkCustomerIsvalid() {
      let res = await this.$refs.SelectCustomer.validatorHandler();
      return res;
    },
    // 更新個資聲明比對基準；確認聲明後，當下客戶資料視為已告知。
    updateTempData() {
      const currentEditing = this.$store.getters.MfEditing;

      this.tempData = this.getCustomerCompareData(currentEditing);
      this.setPrivacyCustomerCompareData(this.tempData);
    },
    // 從 Vuex 取回個資聲明比對基準，保留跨彈窗/返回流程的判斷狀態。
    getPrivacyCustomerCompareData() {
      const privacyTempJSON =
        this.$store.state.mf.privacyCustomerDataTempJSON || "";
      if (!privacyTempJSON) return null;

      try {
        return JSON.parse(privacyTempJSON);
      } catch {
        return null;
      }
    },
    // 寫入個資聲明比對基準，避免重新加入商品後基準遺失。
    setPrivacyCustomerCompareData(compareData) {
      this.$store.commit("set_privacyCustomerDataTempJSON", compareData);
    },
    // 將「客戶資料是否已變更且尚未告知」同步到 Vuex。
    setPrivacyCustomerChanged(isChanged) {
      this.$store.commit("set_privacyCustomerChanged", isChanged);
    },

    // 只取個資聲明需要比對的客戶欄位，避免商品或其他資料影響判斷。
    getCustomerCompareData(currentEditing = {}) {
      const formatCustomer = (customer = {}) => {
        const birthday = this.normalizeCustomerDate(customer.insured_birthday);
        return {
          name: this.normalizeCustomerValue(customer.insured_name),
          gender: this.normalizeCustomerValue(customer.insured_gender),
          birthday,
          age: birthday
            ? ""
            : this.normalizeCustomerValue(customer.insured_age),
        };
      };

      return {
        insurer: formatCustomer(currentEditing.insurer),
        insured: formatCustomer(currentEditing.insured),
      };
    },
    // 將空值與字串格式統一，避免 null/undefined/空白造成誤判。
    normalizeCustomerValue(value) {
      return value === null || value === undefined ? "" : `${value}`.trim();
    },
    // 統一西元與民國日期格式；已有生日時不再用年齡參與比對。
    normalizeCustomerDate(value) {
      if (!value) return "";

      if (value instanceof Date) {
        return moment(value).format("YYYY-MM-DD");
      }

      const normalizedValue = this.normalizeCustomerValue(value);
      const rocDate = normalizedValue.match(
        /^(\d{2,3})[/-](\d{1,2})[/-](\d{1,2})$/,
      );

      if (rocDate) {
        const [, year, month, day] = rocDate;
        return `${Number(year) + 1911}-${month.padStart(2, "0")}-${day.padStart(
          2,
          "0",
        )}`;
      }

      const date = moment(normalizedValue, ["YYYY-MM-DD", "YYYY/MM/DD"], true);
      if (date.isValid()) return date.format("YYYY-MM-DD");

      const fallbackDate = moment(value);
      return fallbackDate.isValid()
        ? fallbackDate.format("YYYY-MM-DD")
        : normalizedValue;
    },

    // 個資聲明確認後更新比對基準，再回到原本的儲存流程。
    async confirmWarningModal() {
      this.updateTempData();
      this.hasConfirmedWarning = true;
      this.hasUnconfirmedCustomerChange = false;
      this.setPrivacyCustomerChanged(false);

      this.warningModalOpen = false;
      await this.panelClose("warningModalOpen");

      this.saveAndNext();
    },
    // 比對目前客戶資料與上次個資聲明確認時的資料是否不同。
    isCustomerChanged() {
      const currentEditing = this.$store.getters.MfEditing;
      const now = this.getCustomerCompareData(currentEditing);

      return !_.isEqual(this.tempData, now);
    },
    // 客戶資料 watcher 進來時同步異動狀態；初始化尚未完成時不判斷。
    syncCustomerChanged() {
      if (!this.customerChangeTrackingReady) return;
      const isChanged = this.isCustomerChanged();
      this.hasUnconfirmedCustomerChange = isChanged;
      this.setPrivacyCustomerChanged(isChanged);
    },
    // 給本頁 insurer/insured watcher 使用的客戶異動入口。
    trackCustomerChange() {
      this.syncCustomerChanged();
    },
    // 給 SelectCustomer 子元件通知父層使用的客戶異動入口。
    markCustomerChanged() {
      this.syncCustomerChanged();
    },
    // 判斷此時是否需要重新顯示個資聲明彈窗。
    shouldShowPrivacyWarning() {
      return (
        !this.warningModalOpen &&
        this.$store.getters.MfEditing.inputType === "noId" &&
        ((this.$store.getters.MfEditing.isNew && !this.hasConfirmedWarning) ||
          this.hasUnconfirmedCustomerChange ||
          this.$store.state.mf.privacyCustomerChanged ||
          this.isCustomerChanged())
      );
    },
    // 商品資料檢核完成後才呼叫；需要個資聲明時中斷後續儲存流程。
    showPrivacyWarningIfNeeded() {
      this.syncCustomerChanged();
      if (!this.shouldShowPrivacyWarning()) return false;

      this.canSave = true;
      this.popUpWarning();
      return true;
    },
    // 儲存並進入下一步
    async saveAndNext() {
      let currentEditing = this.$store.getters.MfEditing;
      this.warningModalOpen = false;
      this.panelClose("warningModalOpen");
      //確認客戶資料是否都通過檢查
      const customerIsvalid = await this.checkCustomerIsvalid();
      if (customerIsvalid) {
        this.canSave = false;
        let mc_prod_list = this.$store.getters.MfEditing.mc_prod_list;
        if (mc_prod_list.length < 1) {
          this.canSave = true;
          return this.$toast.info({
            title: "請輸入至少一筆主約!",
          });
        }
        //檢核被保人是否在商品白名單內(特殊白名單商品)
        for (let i = 0; i < mc_prod_list.length; i++) {
          let mc = mc_prod_list[i];
          let message = await this.checkProdWhiteList(
            mc.prod_id,
            this.$store.getters.MfEditing.insured.insured_id,
          );
          if (message != "") {
            this.canSave = true;
            return this.$toast.info({
              title: message,
            });
          }
        }

        let Element_SelectProduct = this.$refs.SelectProduct;
        let check = true;
        for (let mc in Element_SelectProduct.$refs) {
          if (Element_SelectProduct.$refs[mc].length > 0) {
            let mcCheak = await Element_SelectProduct.$refs[
              mc
            ][0].validateAll();

            let scElementIndex =
              Element_SelectProduct.$refs[mc][0].$children.length - 1;
            let scCheak = await Element_SelectProduct.$refs[mc][0].$children[
              scElementIndex
            ].validateAll();
            if (!mcCheak || !scCheak) check = false;
          }
        }
        if (!check) {
          this.canSave = true;
          return this.$toast.info({
            title: "請檢視必填欄位是否漏填或填寫內容有誤!",
          });
        }

        //不可單獨附加某些特定豁免附約
        for (let i = 0; i < mc_prod_list.length; i++) {
          let mc = mc_prod_list[i];
          if (
            mc.sc_prod_list.filter((sc) => sc.is_checked == "1").length > 0 &&
            mc.sc_prod_list.filter(
              (sc) => sc.free_prod != "2" && sc.is_checked == "1",
            ).length == 0
          ) {
            let sc = mc.sc_prod_list.filter((sc) => sc.is_checked == "1")[0];
            this.canSave = true;
            return this.$mfNotice(
              `主約不得單獨附加${sc.prod_name}(${sc.prod_id})`,
            );
          }
        }
        //檢查投保前提機制(2022/04/11新增)
        let needPreProdNoticeTotal = "";
        mc_prod_list.forEach((mc, index) => {
          let needPreProdNoticeMc = "";
          mc.sc_prod_list.forEach((nowSc) => {
            let needPrePordList = [];
            if (
              nowSc.is_checked == "1" &&
              nowSc.pre_con_ind == "1" &&
              nowSc.pre_prod_id
            ) {
              nowSc.pre_prod_id.split(",").forEach((preScId) => {
                let preScObj = mc.sc_prod_list.find(
                  (sc) => sc.prod_id == preScId,
                );
                if (preScObj && preScObj.is_checked != "1") {
                  //需勾選該建議，但卻沒勾選
                  needPrePordList.push(
                    `${preScObj.prod_name}(${preScObj.prod_id})`,
                  );
                } else {
                  //因條件是"或"，因此如果其中之一有被勾選，則 needPrePordList 清空
                  needPrePordList = [];
                  return;
                }
              });
            }
            if (needPrePordList.length > 0) {
              needPreProdNoticeMc += `
          欲選取${nowSc.prod_name}(${nowSc.prod_id})，應先選取`;
              needPrePordList.forEach((item) => {
                needPreProdNoticeMc += needPrePordList.join("或");
              });
              needPreProdNoticeMc += "。<br><br>";
            }
          });
          if (needPreProdNoticeMc != "") {
            needPreProdNoticeTotal += `
          <strong>建議${index + 1}：${mc.prod_name}(${mc.prod_id})</strong>
          <br>
          ${needPreProdNoticeMc}
          <br>
          `;
          }
        });
        if (needPreProdNoticeTotal != "") {
          this.canSave = true;
          return this.$mfNotice(
            "請注意！以下建議已違反附約附加規定！",
            null,
            false,
            null,
            "確定",
            needPreProdNoticeTotal,
          );
        }
        //開始處理建議書保存
        currentEditing = this.$store.getters.MfEditing;
        //如果為版型五，拿掉多餘的不定期繳(0902新增)
        if (currentEditing.mc_prod_list[0].FEATURE_DATA.prem_type == "5") {
          let temp__premium = JSON.parse(
            currentEditing.mc_prod_list[0].paymethod || "{}",
          );
          let flexiblePrem = temp__premium.flexiblePrem || [];
          for (let i = 0; i < flexiblePrem.length; i++) {
            if (
              flexiblePrem[flexiblePrem.length - i - 1].end_age * 1 <=
              currentEditing.mc_prod_list[0].dueage * 1
            ) {
              break;
            } else {
              //該筆end年齡不能大於年金，如果連start也大於年金，該筆刪掉
              if (
                flexiblePrem[flexiblePrem.length - i - 1].start_age * 1 >
                currentEditing.mc_prod_list[0].dueage * 1
              ) {
                flexiblePrem.splice(flexiblePrem.length - i - 1, 1);
                i--;
              } else {
                //該筆end年齡不能大於年金，但有滿足start小於年金，end押上年金
                flexiblePrem[flexiblePrem.length - i - 1].end_age =
                  currentEditing.mc_prod_list[0].dueage;
              }
            }
          }
          currentEditing.mc_prod_list[0].paymethod =
            JSON.stringify(temp__premium);
        }
        //如果為版型六，拿掉多餘的不定期繳(0902新增)
        if (currentEditing.mc_prod_list[0].FEATURE_DATA.prem_type == "6") {
          let temp__paymethod = JSON.parse(
            currentEditing.mc_prod_list[0].paymethod || "{}",
          );
          let flexiblePrem = temp__paymethod.flexiblePrem || [];
          for (let i = 0; i < flexiblePrem.length; i++) {
            if (
              flexiblePrem[flexiblePrem.length - i - 1].end_age * 1 <=
              currentEditing.mc_prod_list[0].dueage * 1
            ) {
              break;
            } else {
              //該筆end年齡不能大於年金，如果連start也大於年金，該筆刪掉
              if (
                flexiblePrem[flexiblePrem.length - i - 1].start_age * 1 >
                currentEditing.mc_prod_list[0].dueage * 1
              ) {
                flexiblePrem.splice(flexiblePrem.length - i - 1, 1);
                i--;
              } else {
                //該筆end年齡不能大於年金，但有滿足start小於年金，end押上年金
                flexiblePrem[flexiblePrem.length - i - 1].end_age =
                  currentEditing.mc_prod_list[0].dueage;
              }
            }
          }
          currentEditing.mc_prod_list[0].paymethod =
            JSON.stringify(temp__paymethod);
        }
        let saveData = {
          prod_idx: currentEditing.prod_idx || "", //建議書IDX
          insurer_name: currentEditing.insurer.insured_name,
          insurer_id: currentEditing.insurer.insured_id || "",
          insurer_gender: currentEditing.insurer.insured_gender,
          insurer_birthday: currentEditing.insurer.insured_birthday,
          insurer_age: currentEditing.insurer.insured_age + "",
          insurer_actage: currentEditing.insurer.insured_birthday
            ? moment().diff(
                moment(currentEditing.insurer.insured_birthday),
                "years",
              ) + ""
            : currentEditing.insurer.insured_age + "",
          is_crm: currentEditing.inputType == "family" ? "1" : "0",
          insured_name: currentEditing.insured.insured_name,
          insured_id: currentEditing.insured.insured_id || "",
          insured_gender: currentEditing.insured.insured_gender,
          insured_birthday: currentEditing.insured.insured_birthday,
          insured_age: currentEditing.insured.insured_age + "",
          insured_actage: currentEditing.insured.insured_birthday
            ? moment().diff(
                moment(currentEditing.insured.insured_birthday),
                "years",
              ) + ""
            : currentEditing.insured.insured_age + "",
          mc_prod_list: _.cloneDeep(currentEditing.mc_prod_list),
          total_pre: 0,
        };
        //主約重算保額(投資型不用)
        if (saveData.mc_prod_list[0].FEATURE_DATA.prod_type == "1") {
          for (let i = 0; i < saveData.mc_prod_list.length; i++) {
            try {
              let res = await this.$mfAPI.MFC0_1000__getPremium({
                prod_id: saveData.mc_prod_list[i].prod_id,
                add_method: saveData.mc_prod_list[i].add_method,
                amt: saveData.mc_prod_list[i].amt,
                group_dis: saveData.mc_prod_list[i].group_dis,
                job_cat: saveData.mc_prod_list[i].job_cat,
                pay_dis: saveData.mc_prod_list[i].pay_dis,
                pay_freq: saveData.mc_prod_list[i].pay_freq,
                pay_prd: saveData.mc_prod_list[i].pay_prd,
                pol_period: saveData.mc_prod_list[i].pol_period,
                deferred_prod: saveData.mc_prod_list[i].deferred_prod,
                insured_age:
                  this.$store.getters.MfEditing.insured.insured_age + "",
                insured_gender:
                  this.$store.getters.MfEditing.insured.insured_gender,
              });
              saveData.mc_prod_list[i].premium = res.premium || "0";
            } catch {
              saveData.mc_prod_list[i].premium = "0";
            }
          }
        }
        //建議處理
        saveData.mc_prod_list.forEach((mc) => {
          ///保額加總這邊要加總
          mc.total_premium = parseInt(mc.premium || 0);
          mc.insured_job = mc.job_cat || "";
          mc.sc_prod_list = mc.sc_prod_list.filter((sc) => {
            if (sc.is_checked == "1") {
              mc.total_premium += parseInt(sc.premium || 0);
            }
            return sc.is_checked == "1";
          });
          saveData.total_pre += mc.total_premium;
          mc.total_premium = mc.total_premium.toString();
          mc.sc_prod_list.forEach((item) => {
            if (saveData.insurer_id != "" && saveData.insured_id != "") {
              if (item.insured_id === saveData.insurer_id) {
                item.insured_birthday = saveData.insurer_birthday;
              }
              if (item.insured_id === saveData.insured_id) {
                item.insured_birthday = saveData.insured_birthday;
              }
            }
            item.insured_job = item.job_cat || "";
            if (!item.pay_prd) {
              item.pay_prd = "1";
            }
            if (item.free_prod != "0") {
              item.pay_prd = "";
              item.premium = "";
              item.amt = "";
              item.amt_unit = "";
              item.amt_unit_nm = "";
            }
          });
        });
        saveData.total_pre = saveData.total_pre.toString();
        saveData.prod_type = saveData.mc_prod_list[0].prod_type;
        ///檢核儲存建議書
        let checkSaveProposalRes = await this.checkSaveProposal(
          {
            insured_age: saveData.insured_age,
            mc_prod_list: this.deflationSaveData(saveData).mc_prod_list,
          },
          true,
        );

        //定期險之附約保額限制
        let term_amt_error = "";
        saveData.mc_prod_list.forEach((mc, index) => {
          let term_amt_error_sc = "";
          mc.sc_prod_list.forEach((sc) => {
            if (
              sc.term_amt_ind == "1" &&
              mc.FEATURE_DATA.prod_classify == "002"
            ) {
              if (sc.amt * 1 > sc.term_amt_ceil * 1) {
                term_amt_error_sc += `${sc.prod_name}(${sc.prod_id})保額不得超過${sc.term_amt_ceil}${sc.amt_unit_nm}。
              </br>
                    `;
              }
            }
          });
          if (term_amt_error_sc != "") {
            term_amt_error += `<strong>建議${index + 1}:${mc.prod_name}(${
              mc.prod_id
            })</strong><br>${term_amt_error_sc}<br><br>`;
          }
        });
        if (term_amt_error != "") {
          setTimeout(() => {
            this.$mfNotice(
              "請注意！以下建議已違反保額限制！",
              () => {},
              false,
              null,
              "確定",
              term_amt_error,
            );
          }, 100);
          return (this.canSave = true);
        }

        //通過日額通算才進行保存
        if (checkSaveProposalRes) {
          switch (saveData.mc_prod_list[0].FEATURE_DATA.prod_type) {
            case "1":
              this.save_TD(saveData);
              break;
            default:
              this.save_IV(saveData);
          }
        } else {
          this.canSave = true;
        }
      }
    },
    save_TD(saveData) {
      //傳統型保存
      let currentEditing = this.$store.getters.MfEditing;
      //拿掉多餘的商屬資料(0630新增)
      if (this.showPrivacyWarningIfNeeded()) return;
      let deflationedSaveData = this.deflationSaveData(saveData);
      this.$mfAPI
        .MFA0_1000__saveProposal({
          ...deflationedSaveData,
        })
        .then((res) => {
          this.canSave = true;
          if (res.prod_idx) {
            saveData.prod_idx = res.prod_idx;
            this.$store.commit("update_MfViewing", {
              saveData,
              mc_prod_list: saveData.mc_prod_list,
              prod_idx: res.prod_idx,
              familyid: currentEditing.insured.familyid || this.familyid,
            });
            this.updateClickDate(res.prod_idx, "1");
            this.$router.push("/mf/create/createDetail");
            this.$toast.info({
              title: "建議書儲存成功!",
            });
          } else {
            console.log("沒有idx");
          }
        })
        .catch((message) => {
          // this.$toast.info({ title: message });
          this.$toast.info({ title: "執行失敗" });

          this.canSave = true;
        });
    },
    save_IV(saveData) {
      //變額萬能壽險保存()
      saveData.mc_type = saveData.mc_prod_list[0].FEATURE_DATA.prem_type;
      //投資型儲存檢核
      let checkMessage = this.checkIVSaveData(saveData);
      if (checkMessage != "") {
        this.canSave = true;
        return this.$toast.info({
          title: checkMessage,
        });
      }
      //基金檢核
      let errorMessage = "";
      saveData.mc_prod_list.forEach((mc) => {
        let vaild = true;
        if (!mc.fund) vaild = false;
        //$檢核版型是否合格
        // mc.fund.fund
        // mc.fund.fund_fof
        // mc.fund.fund_sub
        // mc.fund.fund_over
        // mc.fund.fund_interest
        // mc.fund.fund_reflow
        // mc.fund.fund_again
        switch (mc.FEATURE_DATA.fund_type) {
          case "1":
            vaild = mc.fund.fund && mc.fund.fund.length > 0;
            break;
          case "2":
            vaild =
              mc.fund.fund_fof &&
              mc.fund.fund_fof.length > 0 &&
              mc.fund.fund_sub &&
              mc.fund.fund_sub.length > 0;
            break;
          case "3":
            vaild =
              mc.fund.fund_interest &&
              mc.fund.fund_interest.length > 0 &&
              mc.fund.fund_reflow &&
              mc.fund.fund_reflow.length > 0;
          case "4":
            vaild =
              mc.fund.fund &&
              mc.fund.fund.length > 0 &&
              mc.fund.fund_extra &&
              mc.fund.fund_extra.length > 0;
            break;
        }
        if (!vaild) {
          let fund_lmt = parseInt(
            saveData.mc_prod_list[0].FEATURE_DATA.fund_lmt || 10,
          );
          errorMessage =
            "基金勾選數量有誤!至少選擇1檔，最多" + fund_lmt + "檔投資標的!";
        }
      });
      if (errorMessage != "") {
        this.canSave = true;
        return this.$toast.info({
          title: errorMessage,
        });
      }
      let currentEditing = this.$store.getters.MfEditing;
      if (this.showPrivacyWarningIfNeeded()) return;
      //拿掉多餘的商屬資料(0630新增)
      let deflationedSaveData = this.deflationSaveData(saveData);
      this.canSave = true;
      this.$mfAPI
        .MFA0_1000__saveProposal({
          ...deflationedSaveData,
          prem_type: saveData.mc_prod_list[0].FEATURE_DATA.prem_type,
        })
        .then((res) => {
          this.canSave = true;
          if (res.prod_idx) {
            saveData.prod_idx = res.prod_idx;
            this.$store.commit("update_MfViewing", {
              saveData,
              mc_prod_list: saveData.mc_prod_list,
              prod_idx: res.prod_idx,
              familyid: currentEditing.insured.familyid || this.familyid,
            });
            this.updateClickDate(res.prod_idx, "2");
            this.$router.push("/mf/create/createDetail");
            this.$toast.info({
              title: "建議書儲存成功!",
            });
          } else {
            console.log("沒有idx");
          }
        })
        .catch((message) => {
          // this.$toast.info({ title: message });
          this.$toast.info({ title: "執行失敗" });
          this.canSave = true;
        });
    },
    checkIVSaveData(saveData) {
      let checkPremType = ["2", "5", "6", "7", "8"];
      for (let i = 0; i < saveData.mc_prod_list.length; i++) {
        let mc = saveData.mc_prod_list[i];

        //客戶增齡檢核
        if (checkPremType.indexOf(mc.FEATURE_DATA.prem_type) != -1) {
          let paymethod = JSON.parse(mc.paymethod || "{}");
          for (let key in paymethod) {
            let paymethodList = paymethod[key];
            if (!Array.isArray(paymethodList)) continue;
            for (let j = 0; j < paymethodList.length; j++) {
              let item = paymethodList[j];
              if (!item.start_age) continue;
              if (
                (key == "adjAmtFlexible" &&
                  item.start_age * 1 <= saveData.insured_age * 1) ||
                (key != "adjAmtFlexible" &&
                  item.start_age * 1 < saveData.insured_age * 1)
              ) {
                return "因客戶增齡，請檢視年齡相關欄位是否有誤！";
              }
            }
          }
        }
      }
      return "";
    },
    isReadyListenAppJS() {
      this.$nextTick(() => {
        if (window.webkit) {
          window.webkit.messageHandlers.isReadyListenAppJS.postMessage("isOK");
        }
      });
    },
    getKycAPI(MemberList) {
      //提供NAP預帶客戶方法KYC查詢
      let APC_IDList = [];
      MemberList.filter((item) => {
        let obj = {
          APC_ID: item.csidno,
          BRDY: item.birthday,
        };
        APC_IDList.push(obj);
      });
      this.$store.commit("set_allRiskObj", ""); //舊有家戶 riskObj 清空
      this.$mfAPI
        .MFA1_0100__getKYCInfo({
          APC_IDs: APC_IDList,
        })
        .then((res) => {
          this.$store.commit("set_allRiskObj", res);
        })
        .catch((error) => {
          this.$toast.info({
            title: "風險屬性檢核異常，您可以稍後再重新確認",
          });
        });
    },
    getCustInfoFromBox(csid) {
      //提供NAP預帶客戶方法(參考index.vue的beforeRouteEnter方法)
      let vm = this;
      vm.$store.commit("reset_Customer");
      let importMember = async (targetId) => {
        const { data } = await getFamilyMemberByCsidNo(
          vm.$store.getters.UserInfo.id,
          targetId,
        );
        data.forEach((item) => {
          item.insured_name = item.name;
          item.insured_id = item.csidno;
          item.insured_gender = item.sex;
          item.insured_birthday =
            !item.birthday || item.birthday === ""
              ? ""
              : moment(item.birthday + "").format("YYYY-MM-DD");
          item.insured_age = item.age + "";
          item.job_cat = "";
          item.check = true;
        });
        vm.getKycAPI(data);
        if (!data[0]) return console.log("家戶沒人");
        data.sort((a, b) => {
          return a.familyrl - b.familyrl;
        });
        vm.$store.commit("set_MemberList", data);
        let targetPeople = data.find((item) => item.insured_id == targetId);
        vm.$store.commit("update_MfEditing", {
          inputType: "family",
          insured: _.cloneDeep(targetPeople),
          insurer: _.cloneDeep(targetPeople),
          sameInsurer: false,
        });
        vm.$nextTick(() => {
          vm.$refs.SelectCustomer &&
            vm.$refs.SelectCustomer.refreshInsuranceAgingNotify();
        });
        //新增查詢預帶參數(2022/10/18)
        vm.$store.commit("update_queryDetailTarget", {
          is_crm: "1",
          insured_id: targetPeople.familyid,
          prod_idx: "",
          familyid: targetPeople.familyid,
        });
      };
      importMember(atob(csid));
    },
    //傳遞base64格式資料給APP
    boxSendBase64PdfData(buffer) {
      this.$nextTick(() => {
        if (window.webkit) {
          // let str = String.fromCharCode.apply(null, new Uint8Array(buffer));
          let str = "";
          let chunk = 8 * 1024;
          let i;
          let array = new Uint8Array(buffer);
          for (i = 0; i < array.length / chunk; i++) {
            str += String.fromCharCode.apply(
              null,
              array.slice(i * chunk, (i + 1) * chunk),
            );
          }
          str += String.fromCharCode.apply(null, array.slice(i * chunk));
          window.webkit.messageHandlers.getBase64PdfData.postMessage(btoa(str));
        }
      });
    },
    openPdfLoadingWindow(newWindow = window.open("")) {
      newWindow.document.write(`
          <html style="height: 100%;">
          <head>
          <meta name="viewport" content="width=device-width, minimum-scale=0.1">
          <title>PDF LOADING...</title>
          </head>
          <body style="margin: 0px; background: #0e0e0e; height: 100%">
          <div><img style="position: absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto;" src="/crm/assets/common/mv-pdf-loader.gif"></div>
          </body></html>
      `);
      return newWindow;
    },
    async getPrivacyNoticePdfErrorMessage(buffer) {
      try {
        const { header } = await new Response(
          new Blob([buffer], { type: "application/json" }),
        ).json();
        if (header && parseInt(header.status, 10) < 0) {
          return header.message;
        }
      } catch {
        return "";
      }
      return "";
    },
    async printPrivacyNoticePDF(newWindow) {
      const { data } = await this.$mfAPI.MFA0_1000__previewPrivacyNoticePDF();
      const errorMessage = await this.getPrivacyNoticePdfErrorMessage(data);
      if (errorMessage) {
        return swal(errorMessage, ``, "error");
      }

      if (this.isBox && !this.$store.getters.IsBankUser) {
        this.boxSendBase64PdfData(data);
        return;
      }

      let file = new Blob([data], { type: "application/pdf" });
      let fileURL = URL.createObjectURL(file);
      newWindow.location = fileURL;
      setTimeout(() => {
        newWindow.document.title = "個人資料保護法應告知事項";
      }, 100);
    },
    async download() {
      const isBoxApp = this.isBox && !this.$store.getters.IsBankUser;
      const newWindow = isBoxApp
        ? null
        : this.openPdfLoadingWindow(window.open(""));
      this.printPrivacyNoticePDF(newWindow);
    },
    panelOpen(name) {
      this[name] = true;
      document.querySelector("body").classList.add("modal-open");
    },
    panelClose(name) {
      return new Promise((resolve) => {
        var open = document.querySelectorAll(".modal.is-open"),
          elem = open[open.length - 1];
        if (elem) {
          elem.className += " is-out";
          elem.classList.remove("is-out");
        }
        if (open && open.length >= 1) {
          document.querySelector("body").classList.remove("modal-open");
        }
        this[name] = false;
        resolve();
      });
    },
    // 開啟新一輪個資聲明時，checkbox 必須重新由使用者勾選。
    popUpWarning() {
      this.warningConfirmCheckbox = false;
      this.warningMessage =
        "為確保客戶(潛在客戶)個人資料權益，請告知以下內容，並確實取得同意，為其進行資料建檔。";
      this.panelOpen("warningModalOpen");
    },
    openSendEmailModal() {
      this.panelClose("warningModalOpen");
      this.panelOpen("sendEmailModalOpen");
    },
    closeEmailModal() {
      this.panelClose("sendEmailModalOpen");
      this.panelOpen("warningModalOpen");
    },
    doSendEmail(form) {
      this.$mfAPI
        .MFA0_1000__sendPrivacyNoticeMail(form)
        .then((result) => {
          const message =
            (result && result.header && result.header.message) ||
            (result && (result.message || result.result_message)) ||
            "發送成功!";
          this.setToastMsg(message);
        })
        .catch((message) => {
          this.setToastMsg(message || "執行失敗");
        });
    },
  },
  watch: {
    //要保人
    insurer: {
      handler(val) {
        this.$store.commit("update_MfEditing", {
          insurer: val,
        });
        this.registerHanlink();
        this.trackCustomerChange();
      },
      deep: true,
    },
    //被保人
    insured: {
      handler(val) {
        this.$store.commit("update_MfEditing", {
          insured: val,
        });
        this.registerHanlink();
        this.trackCustomerChange();
      },
      deep: true,
    },
    //已選商品清單
    mainProductSelected: {
      handler(val) {
        this.$store.commit("update_MfEditing", {
          mc_prod_list: val,
        });
      },
      deep: true,
    },
    "mainProductSelected.length": function (newValue, oldValue) {
      if (newValue != 0 && oldValue == 0)
        this.$store.commit("set_customerDataTempJSON");
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/mf/create/createDetail") {
      // this.$store.commit("set_MemberList", []);
      setTimeout(() => {
        this.$store.commit("reset_MfEditing");
      }, 500);
      next();
    } else if (
      to.path == "/mf/create/addPayment" ||
      to.path == "/mf/create/investmentTarget" ||
      to.path == "/mf/create/addPremium" ||
      to.path == "/mf/create/PremiumPreview" ||
      to.path == "/mf/create/addPayment2" ||
      to.path == "/mf/create/addPayment3"
    ) {
      next();
    } else {
      let reset = () => {
        // this.$store.commit("set_MemberList", []);
        setTimeout(() => {
          this.$store.commit("reset_MfEditing");
        }, 500);
        next();
      };
      if (this.$store.getters.MfEditing.mc_prod_list.length == 0) {
        return reset();
      }
      this.$mfNotice(
        "本建議書尚未完成，是否確定放棄?",
        () => {
          reset();
        },
        true,
        null,
        "確定放棄",
        "",
        "",
        "繼續輸入",
      );
    }
  },
};
</script>

<style></style>
